import { render, staticRenderFns } from "./BotConfiguration.vue?vue&type=template&id=17376419&"
import script from "./BotConfiguration.vue?vue&type=script&lang=js&"
export * from "./BotConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports